import _slicedToArray from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import Postmate from "@/lib/postmate";
Postmate.debug = false;
import data from "../tools/page.json";
import { returnCurLang } from "../tools/utils";
import { mapState, mapGetters } from "vuex";
import { moveUpAt, moveDownAt, removeAt } from "@/pages/design/common/array";
import { genIdFn } from "@/utils/util";
var idFn = genIdFn();
import axios from 'axios';
import { Modal, message } from "ant-design-vue";
import CategoryJson from '../tools/categorys.json';
import { initLang } from "../tools/utils";
export default {
  data: function data() {
    return {
      // parent: undefined,

      hand: "",
      // postmate
      // parent: '', // postmate parent
      iframeHeight: 0,
      // iframe高度
      top: 0,
      // sidebar 距离顶部的值
      sideTop: 0,
      // 计算后的操作栏top,
      index: 0,
      // iframe 点击的item index
      coms: [],
      // 组件列表,
      location: "",
      // 操作栏在哪一侧
      // showOp: false, // 显示操作栏,
      showLangDialog: false,
      // 显示切换语言dialog
      langId: 2,
      // iframe中的langId
      langList: [{
        label: "简体",
        value: 2
      }, {
        label: "日文",
        value: 3
      }, {
        label: "繁体",
        value: 4
      }],
      showAddAsideDialog: false,
      // 添加aside弹窗
      asideList: [{
        label: "原产地",
        value: "SourceArea"
      }, {
        label: "运输方式",
        value: "Transport"
      }, {
        label: "品牌",
        value: "Brand"
      }, {
        label: "分类",
        value: "Category"
      }, {
        label: "链接",
        value: "Link"
      }, {
        label: "菜单",
        value: "Menu"
      }],
      selectedAsideType: undefined,
      // 选中的aside type
      selectedMenuType: undefined,
      // menu类型中添加菜单时选中的menu type
      categorys: '',
      // 分类
      selectedCategoryType: undefined,
      // 选择的分类
      simpleTypes: [{
        value: 'link',
        label: '链接'
      }, {
        value: 'category',
        label: '分类'
      }],
      selectedSimpleType: undefined //选择的一级菜单分类
    };
  },
  mounted: function mounted() {
    this.getData();
    this.design();
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    pageData: function pageData(state) {
      return state.designCategory.pageData;
    },
    com: function com(state) {
      return state.designCategory.select_com;
    },
    select_simple_com: function select_simple_com(state) {
      return state.designCategory.select_simple_com;
    },
    showOp: function showOp(state) {
      return state.designCategory.showOp;
    },
    showSimpleOp: function showSimpleOp(state) {
      return state.designCategory.showSimpleOp;
    },
    scale: function scale(state) {
      var scale = state.designCategory.scale;
      var num = parseInt(scale) / 100;
      return num;
    },
    selectedId: function selectedId(state) {
      return state.designCategory.select_id;
    },
    selectRightId: function selectRightId(state) {
      var id = state.designCategory.select_right_id;
      if (!id) return;
      var _id$split = id.split("-"),
        _id$split2 = _slicedToArray(_id$split, 2),
        asideId = _id$split2[0],
        rightId = _id$split2[1];
      return parseInt(rightId);
    }
  })), {}, {
    lang: function lang() {
      var _this = this;
      var langObj = this.langList.filter(function (item) {
        return item.value === _this.langId;
      })[0];
      if (langObj) {
        return langObj.label.substring(0, 1);
      } else {
        return "";
      }
    },
    iconDownDisabled: function iconDownDisabled() {
      if (this.location === "right") {
        return this.com && this.index === this.com.sublist.length - 1;
      } else {
        return this.index === this.pageData.mutil.length - 1;
      }
    },
    isShowDelete: function isShowDelete() {
      if (this.location === 'aside') {
        return true;
      } else {
        if (this.com.type === 'SourceArea') {
          return false;
        } else if (this.com.type === 'Transport') {
          return false;
        } else {
          return true;
        }
      }
      return true;
    } // ...mapGetters({
    //   getIndex: 'designCategory/getIndex'
    // })
  }),
  watch: {
    pageData: {
      handler: function handler() {
        if (this.parent) {
          var _data = returnCurLang(_.cloneDeep(this.pageData), this.langId);
          console.log("manager data", _data);
          this.parent.call("setPageData", _data);
        }
      },
      deep: true
    },
    com: function com() {
      if (this.parent) {
        this.parent.call("setCom", this.com);
      }
    },
    top: function top() {
      var _this2 = this;
      setTimeout(function () {
        var sideDom = document.querySelector(".op-wrapper");
        var top = 0;
        if (sideDom) {
          var distance = _this2.iframeHeight - _this2.top;
          if (distance < sideDom.clientHeight) {
            top = _this2.top - sideDom.clientHeight;
          } else {
            top = _this2.top;
          }
        }
        _this2.sideTop = top + "px";
      }, 0);
      // return top + 'px'
    } // getIndex(){
    //   this.index = this.getIndex
    // }
  },
  methods: {
    handleSimpleOp: function handleSimpleOp(fn, list) {
      var _this3 = this;
      var index;
      this.pageData.simple.forEach(function (item, i) {
        if (item.id === _this3.select_simple_com.id) {
          index = i;
        }
      });
      if (typeof index === 'undefined') return;
      fn.call(this, list, index);
    },
    handleSimpleMoveUp: function handleSimpleMoveUp() {
      this.handleSimpleOp(moveUpAt, this.pageData.simple);
    },
    handleSimpleMoveDown: function handleSimpleMoveDown() {
      this.handleSimpleOp(moveDownAt, this.pageData.simple);
    },
    handleSimpleRemove: function handleSimpleRemove() {
      var _this4 = this;
      // 删除后激活
      var index;
      this.pageData.simple.forEach(function (item, i) {
        console.log(item.id, '====', _this4.select_simple_com.id);
        if (item.id === _this4.select_simple_com.id) {
          index = i;
        }
      });
      if (typeof index !== 'undefined') {
        if (index === this.pageData.simple.length - 1) {
          index = index - 1;
        } else {
          index = index + 1;
        }
        if (this.pageData.simple[index]) {
          var nextCom = this.pageData.simple[index];
          this.handleSimpleOp(removeAt, this.pageData.simple);
          this.$store.commit("designCategory/setSelectSimpleCom", nextCom);
          this.parent.call('setSelectSimpleCom', nextCom);
        } else {
          this.handleSimpleOp(removeAt, this.pageData.simple);
          this.$store.commit("designCategory/setSelectSimpleCom", "");
          this.$store.commit("designCategory/setShowSimpleForm", false);
          this.$store.commit("designCategory/setShowSimpleOp", false);
        }
      } else {
        this.handleSimpleOp(removeAt, this.pageData.simple);
        this.$store.commit("designCategory/setSelectSimpleCom", "");
        this.$store.commit("designCategory/setShowSimpleForm", false);
        this.$store.commit("designCategory/setShowSimpleOp", false);
      }
    },
    handleSelectCategory: function handleSelectCategory(val) {
      this.selectedCategoryType = val;
    },
    handleSelectAddAside: function handleSelectAddAside(val) {
      this.selectedAsideType = val;
    },
    handleAddAside: function handleAddAside(f, type, index) {
      var _this5 = this;
      if (!this.selectedAsideType) return;
      var title = "";
      var id = idFn();
      switch (this.selectedAsideType) {
        case "SourceArea":
          // id = 1
          title = "原产地";
          break;
        case "Transport":
          // id= 2
          title = "运输方式";
          break;
        case "Brand":
          // id = 3
          title = "品牌";
          break;
        case "Category":
          // id = idFn()
          title = "调味品";
          break;
        case "Link":
          // id = idFn()
          title = "链接";
          break;
        case "Menu":
          // id = idFn()
          title = "菜单";
          break;
      }
      var obj = {
        id: id,
        type: this.selectedAsideType,
        title: {},
        categoryid: "0",
        link: "",
        firstColor: "#1E1E1E",
        firstCheckColor: "#B4A172",
        secondColor: "#1E1E1E",
        sublist: ""
      };
      initLang(obj.title, title);
      if (this.selectedAsideType === 'Category') {
        // 如果没选中具体调味品就给提示然后返回
        if (!this.selectedCategoryType) {
          this.$message.warning('请选择具体分类');
          return;
        }
        var c = this.categorys.filter(function (item) {
          return item.id === _this5.selectedCategoryType;
        })[0];
        if (c) {
          initLang(obj.title, c.settingName);
        }
        obj.categoryid = this.selectedCategoryType;
      }

      // 激活添加的组件
      this.$store.commit("designCategory/setSelectedId", obj.id);
      this.$store.commit("designCategory/setSelectedCom", obj);

      // 设置iframe内选择的组件
      this.parent.call("setSelectedCom", obj);
      if (!type) type = "up";
      if (type === "up") {
        if (typeof index !== "undefined") {
          if (index === 0) {
            this.pageData.mutil.unshift(obj);
          } else {
            this.pageData.mutil.splice(index, 0, obj);
          }
        } else {
          this.pageData.mutil.push(obj);
        }
      } else if (type === "down") {
        if (typeof index !== "undefined") {
          if (index === this.pageData.mutil.length - 1) {
            this.pageData.mutil.push(obj);
          } else {
            this.pageData.mutil.splice(index + 1, 0, obj);
          }
        }
      }
      this.selectedAsideType = undefined;
      this.selectedCategoryType = undefined;
      this.$store.commit('designCategory/setShowOp', true);
      return f();
    },
    handleAddCancel: function handleAddCancel() {
      this.selectedAsideType = undefined;
      this.selectedCategoryType = undefined;
    },
    handleLangChange: function handleLangChange(item) {
      this.langId = item.value;
      this.showLangDialog = false;
      if (this.parent) {
        this.parent.call("setPageData", returnCurLang(_.cloneDeep(this.pageData), this.langId));
      }
    },
    sort: function sort(res) {
      var targetRow = this.pageData.mutil.splice(res.oldIndex, 1)[0];
      this.pageData.mutil.splice(res.newIndex, 0, targetRow);
    },
    contentSort: function contentSort(res) {
      var targetRow = this.com.sublist.splice(res.oldIndex, 1)[0];
      this.com.sublist.splice(res.newIndex, 0, targetRow);
    },
    handleOp: function handleOp(fn, list) {
      var _this6 = this;
      var index;
      list.forEach(function (item, i) {
        if (_this6.location === "right") {
          if (item.id === _this6.selectRightId) {
            index = i;
          }
        } else {
          if (item.id === _this6.selectedId) {
            index = i;
          }
        }
      });
      if (typeof index === "undefined") return;
      fn.call(this, list, index);
    },
    handleRemove: function handleRemove() {
      var _this7 = this;
      if (this.location === 'right') {
        this.handleOp(removeAt, this.com.sublist);
        this.$store.commit("designCategory/setSelectRightCom", "");
        this.$store.commit("designCategory/setSelectRightId", "");
        this.$store.commit("designCategory/setShowOp", false);
      } else {
        // 删除后激活下一个

        var index;
        this.pageData.mutil.forEach(function (item, i) {
          if (item.id === _this7.com.id) {
            index = i;
          }
        });
        // 一, 如果index存在 就判断是不是最后一个 如果是 激活上一个否则激活下一个
        if (typeof index !== 'undefined') {
          if (index === this.pageData.mutil.length - 1) {
            index = index - 1;
          } else {
            index = index + 1;
          }

          // 判断组件是否存在 如果存在就激活 不存在就设为空
          if (this.pageData.mutil[index]) {
            var nextCom = this.pageData.mutil[index];

            // 注意!!! 一定要先删除后激活 不然删除的就是激活的那一个
            this.handleOp(removeAt, this.pageData.mutil);
            this.$store.commit("designCategory/setSelectedCom", nextCom);
            this.$store.commit("designCategory/setSelectedId", nextCom.id);
            this.parent.call('setSelectedCom', nextCom);
          } else {
            this.handleOp(removeAt, this.pageData.mutil);
            this.$store.commit("designCategory/setSelectedCom", "");
            this.$store.commit("designCategory/setSelectedId", "");
            this.$store.commit("designCategory/setShowOp", false);
          }
        } else {
          this.handleOp(removeAt, this.pageData.mutil);
          this.$store.commit("designCategory/setSelectedCom", "");
          this.$store.commit("designCategory/setSelectedId", "");
          this.$store.commit("designCategory/setShowOp", false);
        }
      }
    },
    handleMoveUp: function handleMoveUp() {
      if (this.location === "right") {
        this.handleRightMoveUp();
      } else {
        this.handleOp(moveUpAt, this.pageData.mutil);
      }
    },
    handleRightMoveUp: function handleRightMoveUp() {
      this.handleOp(moveUpAt, this.com.sublist);
    },
    handleMoveDown: function handleMoveDown() {
      // TODO iframe 接收到数据了 但是没有更新
      if (this.location === "right") {
        this.handleRightMoveDown();
      } else {
        this.handleOp(moveDownAt, this.pageData.mutil);
      }
    },
    handleRightMoveDown: function handleRightMoveDown() {
      this.handleOp(moveDownAt, this.com.sublist);
    },
    getData: function getData() {
      var _this8 = this;
      this.$store.commit("designCategory/setPageData", data);
      this.$store.commit("designCategory/setImgHost", data.host);

      // active first
      if (data.mutil.length > 0) {
        setTimeout(function () {
          _this8.$store.commit("designCategory/setSelectedId", data.mutil[0].id);
          _this8.$store.commit("designCategory/setSelectedCom", data.mutil[0]);
          // this.location = 'aside'
          // this.index = 0
          // this.$store.commit('designCategory/setShowOp', true)
        }, 0);
      }

      // axios.get('http://localhost:3000/static/categorys.json').then(res=> res.data)
      //     .then(res => {
      //       if (res.code === 200){
      //         this.categorys = res.data
      //       }
      //     })

      this.categorys = CategoryJson.data;
    },
    design: function design() {
      var self = this;
      this.hand = new Postmate({
        container: document.querySelector(".canvas"),
        url: process.env.VUE_APP_API_APP_CATEGORY_PREVIERW,
        name: "frame"
      });
      this.hand.then(function (p) {
        if (!self.parent) {
          self.parent = p;
          window.frameParent = p;
        }
        var val = returnCurLang(_.cloneDeep(data), 2);
        p.get("height").then(function (height) {
          self.iframeHeight = height;
        });
        p.call("init", val);
        p.on("setLangId", function (id) {
          return self.setLangId(id);
        });
        p.on("asideAdd", function () {
          return self.asideAdd();
        });
        p.on("setAsideTop", function (res) {
          return self.setAsideTop(res);
        });
        p.on("setAsideIndex", function (res) {
          return self.setAsideIndex(res);
        });
        p.on("setAsideCom", function (res) {
          return self.setAsideCom(res);
        });
        p.on("asideUpAddClick", function (index) {
          return self.asideUpAddClick(index);
        });
        p.on("asideDownAddClick", function (index) {
          return self.asideDownAddClick(index);
        });
        p.on("sort", function (res) {
          return self.sort(res);
        });
        p.on("setSublist", function (data) {
          return self.setSublist(data);
        });
        p.on("contentSort", function (res) {
          return self.contentSort(res);
        });
        p.on("setRightCom", function (res) {
          return self.setRightCom(res);
        });
        p.on("subMenuAdd", function (res) {
          return self.subMenuAdd(res);
        });
        p.on('menuUpAddClick', function (res) {
          return self.menuUpAddClick(res);
        });
        p.on('menuDownAddClick', function (res) {
          return self.menuDownAddClick(res);
        });
        p.on('simpleAdd', function () {
          return self.simpleAdd();
        });
        p.on('rightSimpleClick', function (res) {
          return self.rightSimpleClick(res);
        });
        p.on('simpleSort', function (res) {
          return self.simpleSort(res);
        });
        p.on('categorySort', function (res) {
          return self.categorySort(res);
        });
        p.on('setCategoryCom', function (res) {
          return self.setCategoryCom(res);
        });
        p.on('hideForm', function () {
          return self.hideForm();
        });
        p.on('setShowOp', function () {
          return self.setShowOp();
        });
        p.on('setShowSimpleOp', function () {
          return self.setShowSimpleOp();
        });
        p.on('activeFirstSimple', function () {
          return self.activeFirstSimple();
        });
        p.on('demosay', function () {
          console.log('demosay!!!!!!!!!!!!!!!!!');
        });
      });
    },
    activeFirstSimple: function activeFirstSimple() {
      if (this.pageData.simple.length) {
        this.$store.commit('designCategory/setSelectSimpleCom', this.pageData.simple[0]);
        this.$store.commit('designCategory/setShowSimpleOp', true);
      }
    },
    setShowSimpleOp: function setShowSimpleOp() {
      this.$store.commit('designCategory/setShowSimpleOp', true);
    },
    setShowOp: function setShowOp() {
      this.$store.commit('designCategory/setShowOp', true);
    },
    hideForm: function hideForm() {
      this.$store.commit('designCategory/setShowComponentForm', false);
    },
    setCategoryCom: function setCategoryCom(_ref) {
      var top = _ref.top,
        index = _ref.index,
        pindex = _ref.pindex;
      var rcom, id;
      if (typeof pindex !== 'undefined') {
        rcom = this.com.sublist[pindex].sublist[index];
        id = "".concat(pindex, "-").concat(index);
      } else {
        rcom = this.com.sublist[index];
        id = index + '';
      }
      if (rcom) {
        this.$store.commit('designCategory/setSelectRightId', id);
        this.$store.commit('designCategory/setSelectRightCom', rcom);
      } else {
        console.log('没有找到选择的分类菜单');
      }
      this.$store.commit('designCategory/setShowOp', false);
    },
    categorySort: function categorySort(res) {
      if (!this.com.sublist) return;
      if (this.com.sublist.length) {
        if (this.com.sublist[0].sublist) {
          // 是3级分类
          var targetRow = this.com.sublist[0].sublist.splice(res.oldIndex, 1)[0];
          this.com.sublist[0].sublist.splice(res.newIndex, 0, targetRow);
        } else {
          // 是 2级分类
          var _targetRow = this.com.sublist.splice(res.oldIndex, 1)[0];
          this.com.sublist.splice(res.newIndex, 0, _targetRow);
        }
      } else {
        return;
      }
    },
    simpleSort: function simpleSort(res) {
      var targetRow = this.pageData.simple.splice(res.oldIndex, 1)[0];
      this.pageData.simple.splice(res.newIndex, 0, targetRow);
    },
    rightSimpleClick: function rightSimpleClick(res) {
      var com = this.pageData.simple.filter(function (item) {
        return item.id === res.id;
      })[0];
      console.log('com', com);
      if (!com) return;
      this.$store.commit('designCategory/setSelectSimpleCom', com);
      this.$store.commit('designCategory/setShowSimpleForm', true);
      // this.$store.commit('designCategory/setShowComponentForm', true)

      this.$store.commit('designCategory/setShowSimpleOp', true);
    },
    simpleAdd: function simpleAdd() {
      var self = this;
      this.$confirm({
        iconType: '',
        class: 'add',
        title: function title(h) {
          return h('div', {
            attrs: {
              class: 'modal-title'
            }
          }, '新增类型');
        },
        content: function content(h) {
          var arr = [];
          self.simpleTypes.forEach(function (item) {
            arr.push(h("a-select-option", {
              attrs: {
                value: item.value
              }
            }, item.label));
          });
          var categoryVNodes = [];
          if (self.selectedSimpleType === 'category') {
            var categorys = [];
            if (self.categorys) {
              categorys = self.categorys.map(function (item) {
                return h('a-select-option', {
                  attrs: {
                    value: item.id
                  }
                }, item.settingName);
              });
            }
            categoryVNodes.push(h('a-select', {
              style: {
                width: '100%'
              },
              attrs: {
                placeholder: '请选择分类',
                value: self.selectedCategoryType
              },
              on: {
                change: self.handleSelectCategory
              }
            }, categorys));
          }
          return h("div", [h('a-row', {
            style: {
              'margin-bottom': '15px'
            }
          }, [h('a-col', {
            attrs: {
              span: 3
            }
          }, [h("p", "类型")]), h('a-col', {
            attrs: {
              span: 21
            }
          }, [h("a-select", {
            style: {
              width: "100%"
            },
            props: {
              value: self.selectedSimpleType,
              placeholder: "请选择内容类型"
            },
            on: {
              change: self.handleSelectSimpleChange
            }
          }, arr)])

          // h("p", "类型"),
          // h('a-row',[
          //   h('a-col', {
          //     attrs: {
          //       span: 12
          //     }
          //   } ,[
          //       h(
          //       "a-select",
          //       {
          //         style: {
          //           width: "150px",
          //         },
          //         props: {
          //           value: self.selectedSimpleType,
          //           placeholder: "请选择内容类型",
          //         },
          //         on: {
          //           change: self.handleSelectSimpleChange,
          //         },
          //       },
          //       arr
          //   )]),
          //   h('a-col', {
          //     attrs: {
          //       span: 12
          //     }
          //
          //   }, categoryVNodes)
          // ])
          ]), h('a-row', [h('a-col', {
            attrs: {
              offset: 3,
              span: 21
            }
          }, [categoryVNodes])])]);
        },
        onOk: function onOk(f) {
          return self.handleSimpleAdd(f);
        },
        onCancel: function onCancel() {
          self.selectedSimpleType = undefined;
        }
      });
    },
    handleSimpleAdd: function handleSimpleAdd(f) {
      var _this9 = this;
      var obj = {
        "id": idFn(),
        "type": "Link",
        "title": {},
        "textSize": 16,
        "firstColor": "#1E1E1E",
        "firstCheckColor": "#B4A172",
        "image": ""
      };
      if (this.selectedSimpleType === 'category') {
        if (!this.selectedCategoryType) {
          this.$message.warning('请选择具体分类');
          return;
        }
        obj.type = 'Category';
        var c = this.categorys.filter(function (item) {
          return item.id === _this9.selectedCategoryType;
        })[0];
        if (c) {
          initLang(obj.title, c.settingName);
        }
        obj.categoryid = this.selectedCategoryType;
      }
      if (obj.type === 'Link') {
        initLang(obj.title, '默认标题');
        obj.link = '';
      }

      // 选中激活的组件
      this.$store.commit('designCategory/setSelectSimpleCom', obj);
      this.parent.call('setSelectSimpleCom', obj);
      this.pageData.simple.push(obj);
      this.selectedSimpleType = undefined;
      this.selectedCategoryType = undefined;
      this.$store.commit('designCategory/setShowSimpleOp', true);
      this.$store.commit('designCategory/setShowSimpleForm', true);
      return f();
    },
    handleSelectSimpleChange: function handleSelectSimpleChange(val) {
      this.selectedSimpleType = val;
    },
    menuUpAddClick: function menuUpAddClick(_ref2) {
      var index = _ref2.index;
      this.subMenuAdd('up', index);
    },
    menuDownAddClick: function menuDownAddClick(_ref3) {
      var index = _ref3.index;
      this.subMenuAdd('down', index);
    },
    subMenuAdd: function subMenuAdd(type, index) {
      var self = this;
      this.$confirm({
        class: 'add',
        iconType: "",
        title: function title(h) {
          return h('div', {
            attrs: {
              class: 'modal-title'
            }
          }, '新增类型');
        },
        content: function content(h) {
          var typeList = [{
            value: "title",
            label: "标题"
          }, {
            value: "list",
            label: "图文列表"
          }];
          var arr = [];
          typeList.forEach(function (item) {
            arr.push(h("a-select-option", {
              attrs: {
                value: item.value
              }
            }, item.label));
          });
          return h("div", [h('a-row', [h('a-col', {
            attrs: {
              span: 3
            }
          }, [h("p", "类型")]), h('a-col', {
            attrs: {
              span: 21
            }
          }, [h("a-select", {
            style: {
              width: "100%"
            },
            props: {
              value: self.selectedMenuType,
              placeholder: "请选择内容类型"
            },
            on: {
              change: self.handleSelectMenuAdd
            }
          }, arr)])])

          // h("p", "类型"),
          // h(
          //     "a-select",
          //     {
          //       style: {
          //         width: "200px",
          //       },
          //       props: {
          //         value: self.selectedMenuType,
          //         placeholder: "请选择内容类型",
          //       },
          //       on: {
          //         change: self.handleSelectMenuAdd,
          //       },
          //     },
          //     arr
          // ),
          ]);
        },
        onOk: function onOk(f) {
          self.handleAddMenu(f, type, index);
        },
        onCancel: function onCancel() {
          return self.handleCacelAddMenu();
        }
      });
      // let com = this.pageData.mutil.filter((item) => item.id === res.id)[0];
      // if (com) {
      //
      // }
    },
    handleAddMenu: function handleAddMenu(f, type, index) {
      var obj;
      var id = idFn();
      if (this.selectedMenuType === "title") {
        obj = {
          id: id,
          "type": "title",
          "title": {},
          "textSize": 10,
          "textColor": "#1E1E1E",
          "link": ""
        };
        initLang(obj.title, "标题");
      } else if (this.selectedMenuType === "list") {
        obj = {
          id: id,
          "type": "list",
          "linenum": 4,
          "textColor": "#1E1E1E",
          "list": []
        };
        var listobj = {
          "title": {},
          "image": "",
          "link": ""
        };
        initLang(listobj.title, "默认菜单");
        for (var i = 0; i < 4; i++) {
          obj.list.push(listobj);
        }
      }
      if (!this.com.sublist) {
        this.com.sublist = [];
      }
      if (!['up', 'down'].includes(type)) {
        type = 'up';
      }
      if (type === 'up') {
        if (typeof index !== 'undefined') {
          if (index === 0) {
            this.com.sublist.unshift(obj);
          } else {
            this.com.sublist.splice(index, 0, obj);
          }
        } else {
          this.com.sublist.push(obj);
        }
      } else if (type === 'down') {
        if (typeof index !== 'undefined') {
          if (index === this.com.sublist.length - 1) {
            this.com.sublist.push(obj);
          } else {
            this.com.sublist.splice(index + 1, 0, obj);
          }
        }
      }
      var rid = "".concat(this.com.id, "-").concat(obj.id);
      this.$store.commit('designCategory/setSelectRightId', rid);
      this.$store.commit('designCategory/setSelectRightCom', obj);
      this.$store.commit('designCategory/setShowOp', true);
      this.parent.call('setSelectedRightId', rid);
      this.selectedMenuType = undefined;
      return f();
    },
    handleCacelAddMenu: function handleCacelAddMenu() {
      this.selectedMenuType = undefined;
    },
    handleSelectMenuAdd: function handleSelectMenuAdd(val) {
      this.selectedMenuType = val;
    },
    asideAdd: function asideAdd() {
      // this.showAddAsideDialog = true
      this.showAsideModel();
    },
    setLangId: function setLangId(id) {
      // this.langId = id
    },
    setRightCom: function setRightCom(res) {
      var _this0 = this;
      // let com = this.com?.sublist.filter(item => item.id === res.id)
      if (res.id == "") {
        this.$store.commit("designCategory/setSelectRightCom", "");
        this.$store.commit("designCategory/setSelectRightId", "");
        this.$store.commit('designCategory/setShowOp', false);
        return;
      }
      this.$store.commit("designCategory/setShowComponentForm", true);

      // this.$store.commit(
      //   "designCategory/setSelectRightCom",
      //   this.com?.sublist[res.index] || ""
      // );
      // this.$store.commit(
      //     "designCategory/setSelectRightId",
      //     res.id
      // );

      setTimeout(function () {
        var _this0$com;
        _this0.$store.commit("designCategory/setSelectRightCom", ((_this0$com = _this0.com) === null || _this0$com === void 0 ? void 0 : _this0$com.sublist[res.index]) || "");
        _this0.$store.commit("designCategory/setSelectRightId", res.id);
      }, 0);
      this.$store.commit('designCategory/setShowOp', true);

      // this.$store.commit("designCategory/setShowRightForm", true);
    },
    setSublist: function setSublist(data) {
      var index = 0;
      this.pageData.mutil.forEach(function (item, i) {
        if (item.id === data.id) {
          index = i;
        }
      });
      this.pageData.mutil[index].sublist = data.contentData;
    },
    setAsideTop: function setAsideTop(res) {
      this.top = res.top;
      this.location = res.location;
    },
    setAsideIndex: function setAsideIndex(res) {
      this.index = res.index;
    },
    setAsideCom: function setAsideCom(res) {
      // this.$store.commit("designCategory/setShowRightForm", false);
      var com = this.pageData.mutil.filter(function (item) {
        return item.id === res.com.id;
      })[0];
      if (!com) return;
      this.$store.commit("designCategory/setSelectRightId", "");
      this.$store.commit("designCategory/setSelectRightCom", "");
      this.$store.commit("designCategory/setSelectedCom", com);
      this.$store.commit("designCategory/setSelectedId", com.id);
      this.$store.commit("designCategory/setShowComponentForm", true);
      this.$store.commit('designCategory/setShowOp', true);
    },
    showAsideModel: function showAsideModel(type, index) {
      var self = this;
      this.$confirm({
        // width: 450,
        class: 'add',
        iconType: "",
        // icon: '',
        title: function title(h) {
          return h('div', {
            attrs: {
              class: 'modal-title'
            }
          }, '新增类型');
        },
        content: function content(h) {
          // 左侧类型列表
          var arr = [];
          self.asideList.forEach(function (item) {
            arr.push(h("a-select-option", {
              attrs: {
                value: item.value
              }
            }, item.label));
          });

          // 分类列表

          var categoryVNodes = [];
          if (self.selectedAsideType === 'Category') {
            var categorys = [];
            if (self.categorys) {
              categorys = self.categorys.map(function (item) {
                return h('a-select-option', {
                  attrs: {
                    value: item.id
                  }
                }, item.settingName);
              });
            }
            categoryVNodes.push(h('a-select', {
              style: {
                width: '100%'
              },
              attrs: {
                placeholder: '请选择分类',
                value: self.selectedCategoryType
              },
              on: {
                change: self.handleSelectCategory
              }
            }, categorys));
          }
          return h("div", [h('a-row', {
            style: {
              'margin-bottom': '15px'
            }
          }, [h('a-col', {
            attrs: {
              span: 3
            }
          }, [h("p", "类型")]), h('a-col', {
            attrs: {
              span: 21
            }
          }, [h("a-select", {
            style: {
              width: "100%"
            },
            props: {
              value: self.selectedAsideType,
              placeholder: "请选择内容类型"
            },
            on: {
              change: self.handleSelectAddAside
            }
          }, arr)])
          // h('a-col', {
          //   attrs: {
          //     span: 10
          //   }
          //
          // }, categoryVNodes)
          ]), h('a-row', [h('a-col', {
            attrs: {
              offset: 3,
              span: 21
            }
          }, [categoryVNodes])])]);
        },
        onOk: function onOk(f) {
          return self.handleAddAside(f, type, index);
        },
        onCancel: self.handleAddCancel
      });
    },
    asideUpAddClick: function asideUpAddClick(index) {
      this.showAsideModel("up", index);
    },
    asideDownAddClick: function asideDownAddClick(index) {
      this.showAsideModel("down", index);
    }
  }
};